import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/[locale]/rezultate-analize/PageForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
